const initialstate = {
    data:[],
    adddata:[],
   editdata:[],
    deletedata:[],
    
}

const AdminCountrylist =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'ADD_DATA_SUCCESS':
            return { ...state, adddata: action.payload };
        case 'EDIT_DATA_SUCCESS':
              return { ...state, editdata: action.payload };
              case 'DELETE_DATA_SUCCESS':
                return { ...state, deletedata: action.payload };
                default :
                return state;
    }
};
export default AdminCountrylist;